import { render, staticRenderFns } from "./cancelAssetInventory.vue?vue&type=template&id=4aafc326"
import script from "./cancelAssetInventory.vue?vue&type=script&lang=js"
export * from "./cancelAssetInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports